import React from "react";

function ResellerPage() {
  // Styles inline pour la démonstration
  const containerStyle = {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "2rem",
  };

  const videoContainerStyle = {
    marginBottom: "2rem",
    textAlign: "center",
  };

  const videoStyle = {
    maxWidth: "100%",
    borderRadius: "8px",
  };

  const headingStyle = {
    marginBottom: "1rem",
  };

  const resellerListStyle = {
    listStyleType: "none",
    paddingLeft: 0,
  };

  const resellerItemStyle = {
    marginBottom: "0.5rem",
  };

  return (
    <div style={containerStyle}>
      <div style={videoContainerStyle}>
        <h1 style={headingStyle}>Nos Revendeurs</h1>
        <video autoPlay loop muted playsInline style={videoStyle}>
            <source src="/assets/videos/market_place.mp4" type="video/mp4" />
            Your browser does not support the video tag.
      </video>
      </div>

      <ul style={resellerListStyle}>
        <li style={resellerItemStyle}>
          <a
            href="https://www.amazon.fr/Baltee-mobility-connect%C3%A9e-Trottinette-Avertisseur/dp/B0DM2LMSB7/ref=sr_1_1_sspa?__mk_fr_FR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=1KXC5Y1ZSVTV5&dib=eyJ2IjoiMSJ9.O8yTWoCPJ8VM5B2zFQWbxzdl_UmlgxfyJdEkQCE3LeJtCb0_9TOCTGpcYwB8x0b24ic8hY9f0ox9R7jkPJgyYlib6UdcjjSXH7saxf1qrxDe2tb68LfMnjb_x8DIU4LEPFqyWO7qQAoOghxyzcp6aPIM1-WuvARoEG6--Q51AGYGIxE0DyFpiZB8Eorur7Ktd0iCsEbqRftCfiqmH6oQhclCcMK78pqzSlmGQaRuNX6Qezet_htRgm3fcbHrQj2vknGCYYWO3Mmg1IszUlLHx6nlDG_ayj_laFDRSmyUlXY.cPBBEx5Bm4Ta15zNS7TWks0zKYyiS7rJzYZs3BVXc0w&dib_tag=se&keywords=alarme+antivol+v%C3%A9lo&nsdOptOutParam=true&qid=1731409439&sprefix=alarme+antivol+v%C3%A9lo%2Caps%2C97&sr=8-1-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&psc=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Amazon
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.cdiscount.com/le-sport/velos-tandem-tricycle-monocycle-remorque-casque/b01-by-baltee-dispositif-d-alerte-et-de-securite/f-121192412-toa1733307042056.html#mpos=0|mp"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cdiscount
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.decathlon.fr/p/mp/toad/b01-by-baltee-dispositif-d-alerte-et-de-securite-support-pour-velo/_/R-p-1d6e482e-3389-4595-b7ab-329c40bd5c35?mc=1d6e482e-3389-4595-b7ab-329c40bd5c35_c1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Décathlon
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.alltricks.fr/F-41480-antivols/P-2943914-baltee_dispositif_d_alerte_et_de_securite_smartfix_pour_velo___baltee"
            target="_blank"
            rel="noopener noreferrer"
          >
            Alltricks
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.natureetdecouvertes.com/outdoor/velos-accessoires/accessoires/baltee-dispositif-d-alerte-et-de-securi-98896010?query_id=b692c9b34df77fcf18328e31714f1cd2&object_id=315573"
            target="_blank"
            rel="noopener noreferrer"
          >
            Nature et Découvertes
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.e.leclerc/fp/baltee-dispositif-d-alerte-et-de-securite-smartfix-pour-velo-3665151001374"
            target="_blank"
            rel="noopener noreferrer"
          >
            E. Leclerc
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.conforama.fr/jardin-loisirs-sport/loisirs-exterieurs/velo-et-accessoires/baltee-dispositif-d-alerte-et-de-securite-smartfix-pour-velo-et-trottinette/p/F50032124?queryID=082b1f723a1788fc94c9c41deb727c4a"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conforama
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.fnac.com/mp51465507/BALTEE-BALTEE-Dispositif-d-alerte-et-de-securite-SMARTFIX-pour-velo/w-4"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fnac
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://www.darty.com/nav/achat/ref/MC351465507.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Darty
          </a>
        </li>
        <li style={resellerItemStyle}>
          <a
            href="https://fr.ankorstore.com/brand/toad-7978/b01-smartfix-dispositif-dalerte-et-de-securite-4-en-1-pour-velo-5475892"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ankorstore
          </a>
        </li>
      </ul>

      <p>
        Retrouvez nos produits chez ces revendeurs partenaires. Pour toute
        question relative à la disponibilité ou aux services proposés,
        n’hésitez pas à contacter directement le magasin concerné ou 
        notre service client.
      </p>
    </div>
  );
}

export default ResellerPage;
